// extracted by mini-css-extract-plugin
module.exports = {"githubIcon":"icon_githubIcon__A6jf_"};